import React, { useEffect, useState } from 'react';
import styles from './EditableTextField.module.css';
import Tooltip from '../Tooltip/Tooltip';
import { useUnsavedChangesWarning } from '../../../Hooks/useUnsavedChangesWarning';

type EditableTextFieldProps = {
  value: string;
  onChange: (newValue: string) => void;
  canEdit?: boolean;
  disabledTooltip?: string;
  disabledTooltipAlign?: 'top' | 'bottom';
  placeholder?: string;
  className?: string;
  style?: React.CSSProperties;
  type?: 'text' | 'email' | 'password' | 'number';
};

const EditableTextField = ({
  value,
  onChange,
  canEdit = true,
  disabledTooltip,
  disabledTooltipAlign = 'top',
  placeholder = '',
  className,
  style,
  type = 'text'
}: EditableTextFieldProps) => {
  const [localValue, setLocalValue] = useState<string>(value ?? '');
  const [hasUserEdited, setHasUserEdited] = useState(false);

  useEffect(() => {
    setLocalValue(value ?? '');
    setHasUserEdited(false);
  }, [value]);

  useUnsavedChangesWarning(!!canEdit && hasUserEdited && localValue !== (value ?? ''));

  const handleBlur = () => {
    if (localValue !== (value ?? '')) {
      onChange(localValue);
    }
  };

  return (
    <Tooltip 
      text={disabledTooltip || ''} 
      align={disabledTooltipAlign} 
      disabled={canEdit}
    >
      <input
        disabled={!canEdit}
        className={className || styles.input}
        style={style}
        type={type}
        value={localValue}
        onChange={(e) => {
          setHasUserEdited(true);
          setLocalValue(e.target.value);
        }}
        onBlur={handleBlur}
        placeholder={placeholder}
      />
    </Tooltip>
  );
};

export default EditableTextField;
